import { Url } from 'url'
import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type Resource = { id: string; name: string; category: string; screenshot: string; created_at: Date; attachment: { url: string; }[] }

export function useGetResources() {
  return useFetch<Resource[]>(getAbsoluteServerUrl('/resources'), { responseType: 'json' }, [])
}
